module.exports = __webpack_public_path__ + "fcc40ae9a542d001971e53eaed948410.ttf";